/**
 * Fast Track Configuration
 *
 * Defines which sections are included in the Fast Track mode.
 */

export const FAST_TRACK_SECTION_IDS = [
  "basicInformation",
  "groupInfo",
  "parkTicketAccess",
  "parkVisitPlans",
  "accommodation",
  "timeEnergy",
];

export const getFastTrackSections = (allSections) => {
  if (!allSections || !Array.isArray(allSections)) return [];
  return allSections.filter(section => FAST_TRACK_SECTION_IDS.includes(section.id));
};

export const getPersonalizeMoreSections = (allSections) => {
  if (!allSections || !Array.isArray(allSections)) return [];
  return allSections.filter(section => !FAST_TRACK_SECTION_IDS.includes(section.id));
};

export const isFastTrackSection = (sectionId) => {
  return FAST_TRACK_SECTION_IDS.includes(sectionId);
};
